import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { Anchor, Box, type BoxProps, Flex, Text, Title } from '@mantine/core'
import Link from 'next/link'

import { useTranslation } from '@flecto/translations'
import {
  type CoreItem,
  type CoreBundleItem,
  type CoreProduct,
} from '@flecto/types'
import { AvatarItem, Icon, TextItemQuantity } from '@flecto/ui'

import { useProductSlugEncode } from '../../hooks/useProductSlugEncode'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import classes from './styles.module.css'

export type SectionBundleItemsProps = BoxProps & {
  product: CoreProduct
}

export function SectionBundleItems({
  product,
  ...props
}: SectionBundleItemsProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-product' })

  if (!product.bundle) {
    return null
  }

  return (
    <Box {...props}>
      <Title order={4} mb='sm'>
        {t('label_included_items')}
      </Title>
      {product.bundle_attributes?.bundle_items?.map((bi) => (
        <RowBundleItem key={bi.id} bi={bi} />
      ))}
    </Box>
  )
}

function RowBundleItem({ bi }: { bi: CoreBundleItem }) {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-product' })

  const item = bi.item

  const path = useStorePathBuilder()

  const slug = useProductSlugEncode(item as CoreProduct)

  const link = path(`/products/${slug}`)

  return (
    <Box key={item.id} className={classes.item}>
      <AvatarItem item={item} size='sm' />
      <Flex align='center' gap='xs'>
        <TextItemQuantity item={bi as unknown as CoreItem} withX='after' />
        <Text fw={500}>{item.title}</Text>
      </Flex>
      <Link href={link}>
        <Anchor variant='transparent'>
          <Flex align='center' gap='xs'>
            {t('label_item_details')}
            <Icon icon={faArrowRight} />
          </Flex>
        </Anchor>
      </Link>
    </Box>
  )
}
